import { useQuery } from '@tanstack/react-query';
import { ClientBookingWithDetails } from 'happypaws-shared/src/Booking/models/BookingWithDetails';
import { api } from '../../services/api';

export const useGetClientBookings = () => {
  return useQuery({
    queryKey: ['clientBookings'],
    queryFn: async () => {
      const response = await api.get<ClientBookingWithDetails[]>('/bookings/client');
      return response.data;
    },
    staleTime: 2 * 60 * 1000,
  });
};
